<template>
    <kt-panel>
        <action-bar>
            <router-link :to="'/faq-questions/' + cat_id + '/create'" class="btn btn-success mr-2">
                {{ $t('btn.new-question') }}
            </router-link>
        </action-bar>
        <div class="mt-2 mb-2">
            <div class="switch-div">
                همه سوال ها
                <label class="switch m-0 mr-2 ml-2">
                    <input id="category_checkbox" type="checkbox" checked @change="checkbox_changed">
                    <span class="slider round"></span>
                </label>
                سوال های فعال
            </div>
            <div v-for="(question, index) in questions_to_show"
                 :key="index"
                 class="question-list ml-2 mr-2"
                 :id="'question-item-' + index"
            >
                <kt-row>
                    <kt-col lg="11" md="11" xs="12">
                        <div class="accordion accordion-toggle-plus" :id="'question-' + index">
                            <div class="card" style="overflow:inherit">
                                <div class="card-header bg-transparent" id="headingOne">
                                    <div class="card-title collapsed" data-toggle="collapse"
                                         :data-target="'#questionForm-' + index"
                                         :aria-controls="'questionForm-' + index"
                                         v-html="question.question"
                                    >
                                    </div>
                                </div>
                                <div :id="'questionForm-'+ index" class="collapse" :aria-labelledby="'questionForm-' + index" :data-parent="'#question-' + index">
                                    <div class="card-body">
                                        <kt-row id="answer">
                                            <div v-html="question.answer" class="question-content text-justify"></div>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="1" md="1" xs="12">
                        <div class="float-right mr-2 mt-2">
                            <router-link
                                :to="'/faq-questions/' + question.id + '/update'"
                                :title="$t('btn.edit')"
                                class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <i class="fa fa-edit"></i>
                            </router-link>
                            <a v-if="!question.is_deleted"
                                href="#" @click.prevent="deleteQuestion(question.id)"
                                :title="$t('btn.delete')"
                                id="deleteBtn"
                                class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <i class="fa fa-trash bg-red"></i>
                            </a>
                            <a v-else
                                href="#" @click.prevent="restoreQuestion(question.id)"
                                :title="$t('btn.restore')"
                                id="restoreBtn"
                                class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <i class="fa fa-sync-alt"></i>
                            </a>
                        </div>
                    </kt-col>
                </kt-row>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import actionBar from '@/components/custom/action-bar'
import {mapGetters} from "vuex";
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import {FAQService} from "../../../common/api.service";
import toastr from "toastr";
import questions from "@/views/knowledge-management/components/questions.vue";

export default {
    components: {
        actionBar
    },
    data() {
        return {
            cat_id: this.$route.params.hashid,
            questions_to_show: this.questions
        }
    },
    computed: {
        ...mapGetters('FAQ', [
            'questions'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }
            return toastr
        }
    },
    mounted() {
        this.$store.dispatch('FAQ/fetchQuestions', this.cat_id).then(() => {
            this.questions_to_show = this.questions
        }
    )
    },
    methods: {
        deleteQuestion(hashid) {
            if(confirm(i18n.t('confirm.delete_question'))) {
                $('#deleteBtn').addClass('disabled');
                FAQService.deleteQuestion(hashid)
                    .then(response => {
                        this.toastr.success(response.data.message)
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        $('#deleteBtn').removeClass('disabled');
                        this.$store.dispatch('FAQ/fetchQuestions', this.cat_id)
                    })
            }
        },
        restoreQuestion(hashid) {
            if(confirm(i18n.t('confirm.restore_question'))) {
                $('#restoreBtn').addClass('disabled');
                FAQService.restoreQuestion(hashid)
                    .then(response => {
                        this.toastr.success(response.data.message)
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        $('#restoreBtn').removeClass('disabled');
                        this.$store.dispatch('FAQ/fetchQuestions', this.cat_id)
                    })
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#category_checkbox')
            if (!checkbox.is(":checked")) {
                this.questions_to_show = this.questions.filter(
                    function(question) {
                        return question.is_deleted === false
                    }
                )
            }
            else
                this.questions_to_show = this.questions
        }
    }
}
</script>

<style>
.question-content{
    font-size: 14px;
    padding-right: 2em;
    line-height: 2em;
}
.question-list{
    border: 1px solid #dee2e6;
    border-top: none;
    margin-bottom: 0 !important;
}
#question-item-0 {
    border-top: 1px solid #dee2e6 !important;
}
</style>